import { useEffect, useState } from 'react';
import { Item, ItemActiveQuote } from './item-types';
import { Button } from '@mui/material';
import ActiveQuotesDialog from './active-quotes-dialog';
import { useNotificationContext } from '../shared/notification';
import { ItemAPI } from '../../api/item';

type ActiveQuotesHost = {
  item: Item;
};

export default function ActiveQuotesHost(props: ActiveQuotesHost) {
  const { useExceptionHandler } = useNotificationContext();
  const [modalOpen, setModalOpen] = useState(false);
  const [activeQuotes, setActiveQuotes] = useState<ItemActiveQuote[]>([]);

  useEffect(() => {
    setActiveQuotes([]);
    const loadProductActiveQuotes = useExceptionHandler(async () => {
      const { data } = await ItemAPI.getProductActiveQuotes(props.item.item_id);
      setActiveQuotes(data as ItemActiveQuote[]);
    });
    loadProductActiveQuotes();
  }, [props.item.item_id]);

  return (
    <>
      <Button variant='outlined' color='secondary' onClick={() => setModalOpen(true)}>
        View {activeQuotes.length} Recent Quotes/Orders
      </Button>
      <ActiveQuotesDialog
        activeQuotesOpen={modalOpen}
        setActiveQuotesOpen={setModalOpen}
        itemId={props.item.item_id}
        activeQuotes={activeQuotes}
      />
    </>
  );
}
